export default __webpack_public_path__ + "images/202b4704b5ca77fbb4439d4eb128ddf2-lock-white.svg";